import Vue from 'vue'
import Landing from '@/compos/Landing.vue'
import Service from '@/compos/Service.vue'
import hotWorks from '@/compos/hotWorks.vue'
import hotPosts from '@/compos/hotPosts.vue'
import Clients from '@/compos/Clients.vue'
import sayHello from '@/compos/sayHello.vue'
import pageTitle from '@/compos/pageTitle.vue'
import workItems from '@/compos/workItems.vue'
import postItems from '@/compos/postItems.vue'
import Offices from '@/compos/Offices.vue'
import Navmenu from '@/compos/Navmenu.vue'
import Bottom from '@/compos/Bottom.vue'
import Slogan from '@/compos/Slogan.vue'
import caseHead from '@/compos/caseHead.vue'
import Context from '@/compos/Context.vue'
import Profile from '@/compos/Profile.vue'
import moreWorks from '@/compos/moreWorks.vue'
import morePosts from '@/compos/morePosts.vue'
import postHead from '@/compos/postHead.vue'
import Article from '@/compos/Article.vue'
import homeSvg from '@/compos/homeSvg.vue'
import workSvg from '@/compos/workSvg.vue'
import postsSvg from '@/compos/postsSvg.vue'
import contactSvg from '@/compos/contactSvg.vue'
import serviceSvg from '@/compos/serviceSvg.vue'
import iconSvg1 from '@/compos/iconSvg1.vue'
import iconSvg2 from '@/compos/iconSvg2.vue'
import iconSvg3 from '@/compos/iconSvg3.vue'
import iconSvg4 from '@/compos/iconSvg4.vue'
import errorSvg from '@/compos/errorSvg.vue'
import decorate1 from '@/compos/decorate1.vue'
import decorate2 from '@/compos/decorate2.vue'
import decorate3 from '@/compos/decorate3.vue'
import loadingSvg from '@/compos/loadingSvg.vue'
import Loading from '@/compos/Loading.vue'
import noDataSvg from '@/compos/noDataSvg.vue'
import noData from '@/compos/noData.vue'
import noSignalSvg from '@/compos/noSignalSvg.vue'
import noSignal from '@/compos/noSignal.vue'
import callPhoneSvg from '@/compos/callPhoneSvg.vue'
import callPhoneSvg2 from '@/compos/callPhoneSvg2.vue'
import homeTextSvgPc from '@/compos/homeTextSvgPc.vue'
import homeTextSvgMobile from '@/compos/homeTextSvgMobile.vue'
import workPlaceholder from '@/compos/workPlaceholder.vue'
import postsPlaceholder from '@/compos/postsPlaceholder.vue'

Vue.component('fo-bottom', Bottom)
Vue.component('fo-slogan', Slogan)
Vue.component('fo-landing', Landing)
Vue.component('fo-service', Service)
Vue.component('fo-clients', Clients)
Vue.component('fo-offices', Offices)
Vue.component('fo-profile', Profile)
Vue.component('fo-hotWorks', hotWorks)
Vue.component('fo-navmenu', Navmenu)
Vue.component('fo-context', Context)
Vue.component('fo-caseHead', caseHead)
Vue.component('fo-sayHello', sayHello)
Vue.component('fo-hotPosts', hotPosts)
Vue.component('fo-postHead', postHead)
Vue.component('fo-Article', Article)
Vue.component('fo-moreWorks', moreWorks)
Vue.component('fo-morePosts', morePosts)
Vue.component('fo-pageTitle', pageTitle)
Vue.component('fo-workItems', workItems)
Vue.component('fo-postItems', postItems)
Vue.component('fo-homeSvg', homeSvg)
Vue.component('fo-workSvg', workSvg)
Vue.component('fo-postsSvg', postsSvg)
Vue.component('fo-contactSvg', contactSvg)
Vue.component('fo-serviceSvg', serviceSvg)
Vue.component('fo-iconSvg1', iconSvg1)
Vue.component('fo-iconSvg2', iconSvg2)
Vue.component('fo-iconSvg3', iconSvg3)
Vue.component('fo-iconSvg4', iconSvg4)
Vue.component('fo-errorSvg', errorSvg)
Vue.component('fo-decorate1', decorate1)
Vue.component('fo-decorate2', decorate2)
Vue.component('fo-decorate3', decorate3)
Vue.component('fo-loadingSvg', loadingSvg)
Vue.component('fo-loading', Loading)
Vue.component('fo-noSignalSvg', noSignalSvg)
Vue.component('fo-noSignal', noSignal)
Vue.component('fo-noDataSvg', noDataSvg)
Vue.component('fo-noData', noData)
Vue.component('fo-callPhoneSvg', callPhoneSvg)
Vue.component('fo-callPhoneSvg2', callPhoneSvg2)
Vue.component('fo-homeTextSvgPc', homeTextSvgPc)
Vue.component('fo-homeTextSvgMobile', homeTextSvgMobile)
Vue.component('fo-workPlaceholder', workPlaceholder)
Vue.component('fo-postsPlaceholder', postsPlaceholder)



// WEBPACK FOOTER //
// ./src/utils/compos.js